module.exports = "/assets/success-picture@2x.png?WWxJmUl";